import { useSelector } from 'react-redux';

import ConfirmAdImages from './confirm-ad-images/ConfirmAdImages';
import RecreateImages from './recreate-images/RecreateImages';

function ConsumerAdImages() {
  const password = useSelector((state) => state.demoRecreate.password);

  return <>{!password ? <ConfirmAdImages /> : <RecreateImages />}</>;
}

export default ConsumerAdImages;
